package org.moxultimate.topwithmox.dashboard

import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.launch
import org.moxultimate.topwithmox.core.base.ViewModel
import org.moxultimate.topwithmox.core.state.APIState
import org.moxultimate.topwithmox.dashboard.api.DashboardRepository
import org.moxultimate.topwithmox.dashboard.data.DashboardLatestResponse

/**
 * DashboardViewModel
 * Fetches the latest 3 items from each content category on init and exposes
 * the result as a [StateFlow] for the dashboard composable to observe.
 *
 * @property repository Injected repository that performs the /dashboard/latest call.
 */
class DashboardViewModel(
    private val repository: DashboardRepository,
) : ViewModel() {

    private val _latestState = MutableStateFlow<APIState<DashboardLatestResponse>>(APIState.Loading)

    /**
     * latestState
     * Read-only state observed by the dashboard composable.
     * Emits Loading → Success or Error after the network call completes.
     */
    val latestState: StateFlow<APIState<DashboardLatestResponse>> = _latestState

    init {
        loadLatest()
    }

    /**
     * loadLatest
     * Triggers a fresh fetch from /dashboard/latest and updates [latestState].
     * Safe to call multiple times — each call replaces the previous result.
     */
    fun loadLatest() {
        viewModelScope.launch {
            repository.getLatest().collect { _latestState.value = it }
        }
    }
}
